import type { Click } from '@/modules/Editor/backend'
import type { IPoint } from '@/modules/Editor/point'
import { pointInPath } from '@/modules/Editor/point'

export const resolveClick = (point: IPoint, path: IPoint[]): Click => {
  const type = pointInPath(point, path) ? 'remove' : 'add'
  return { ...point, type } as Click
}
